import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import { countries } from 'countries';
import * as Yup from 'yup';
import { requiredFiles } from '../../../useValidateQuestionnaire';
import {
  IncomeOutsideOfTheUsStateValues,
  TPerForeignEmployer,
  TPerForeignEmployerItem,
  updateFieldArrayKey,
  updateKey,
} from './slice';

// predicate:
//       'Displayed in case the user selected "Yes" to the "I have income from outside the US" question.',

export const fields: IBaseField<
  keyof IncomeOutsideOfTheUsStateValues | keyof TPerForeignEmployerItem
>[] = [
  {
    name: 'didYouReceivePaymentsFromANonUsEmployer',
    label: 'Did you receive payments from a non-US Employer?',
    subLabel: () => <p>Wages, bonus, stocks, other allowances.</p>,
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'perForeignEmployer',
        label: 'Per Foreign employer',
        // type: 'record',
        type: 'fieldArray',
        tooltip: '',
        comment: true,
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        predicate: (value) => value === 'yes',
        defaultDependency: {
          foreignieNonUsEmployerName: null,
          isEmployerAForeignCompanyAForeignSubsidiaryOfAUsCompanyOrAUsCompany:
            null,
          employersStreetAddress: null,
          city: null,
          postCode: null,
          country: null,
          grossWagessalaryEarnedWithThisEmployerDuringYear: null,
          didYoureEmployerProvideAnAllowanceOnTopOfDirectSalarycarEducationHomeLeaveEtc:
            null,
          list: null,
          wereContributionsMadeToANonUsPensionPlanwhetherYourselfOrByYourEmployer:
            null,
          didYourEmployerContributeToYourPensionPlan: null,
          amountYourEmployerContributed: null,
        },
        dependencies: [
          {
            name: 'foreignieNonUsEmployerName',
            label: 'Foreign (ie Non-US) employer name',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter',
          },
          {
            name: 'isEmployerAForeignCompanyAForeignSubsidiaryOfAUsCompanyOrAUsCompany',
            label:
              'Is Employer a foreign company, a foreign subsidiary of a US company, or a US company?',
            type: 'select',
            options: [
              {
                label: 'Foreign Company',
                value: 'Foreign Company',
              },
              {
                label: 'Foreign Subsidiary of a US Company',
                value: 'Foreign Subsidiary of a US Company',
              },
              {
                label: 'US Company',
                value: 'US Company',
              },
              {
                label: 'International Organization',
                value: 'International Organization',
              },
              {
                label: 'Other',
                value: 'Other',
              },
            ],
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'employersStreetAddress',
            label: "Employer's street address",
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter',
          },
          {
            name: 'city',
            label: 'City',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter',
          },
          {
            name: 'postCode',
            label: 'Post Code',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter',
          },
          {
            name: 'country',
            label: 'Country',
            type: 'country',
            placeholder: 'Select Country',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'grossWagessalaryEarnedWithThisEmployerDuringYear',
            label:
              'Gross wages/salary earned with this employer during {year}?',
            subLabel: () => (
              <p>Utilize the income calculator to convert to calendar year</p>
            ),
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'didYoureEmployerProvideAnAllowanceOnTopOfDirectSalarycarEducationHomeLeaveEtc',
            label:
              'Did your employer provide an allowance on top of direct salary (car, education, home leave, etc)',
            type: 'radio',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            dependencies: [
              {
                name: 'list',
                label: 'List',
                type: 'fieldArray',
                tooltip: '',
                comment: true,
                effect: (payload) =>
                  store.dispatch(updateFieldArrayKey(payload)),
                predicate: (value) => value === 'yes',
                defaultDependency: {
                  descriptionOfAllowance: null,
                  amount: null,
                },
                dependencies: [
                  {
                    name: 'descriptionOfAllowance',
                    label: 'Description of Allowance',
                    type: 'text',
                    tooltip: '',
                    comment: true,
                    predicate: (value) => value === 'yes',
                    effect: updateKeyInStore(updateKey),
                    placeholder: 'Enter',
                  },
                  {
                    name: 'amount',
                    label: 'Amount',
                    type: 'currency',
                    tooltip: '',
                    comment: true,
                    predicate: (value) => value === 'yes',
                    effect: updateKeyInStore(updateKey),
                  },
                ],
              },
            ],
          },

          {
            name: 'wereContributionsMadeToANonUsPensionPlanwhetherYourselfOrByYourEmployer',
            label:
              'Were contributions made to a non-US pension plan (whether yourself or by your employer)?',
            type: 'radio',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            dependencies: [
              {
                name: 'didYourEmployerContributeToYourPensionPlan',
                label: 'Did your employer contribute to your pension plan?',
                subLabel: () => (
                  <p>
                    Such as Pillar II, Superannuation, KiwiSaver, Employer
                    Matching Contribution, etc
                  </p>
                ),
                type: 'radio',
                predicate: (value) => value === 'yes',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                dependencies: [
                  {
                    name: 'amountYourEmployerContributed',
                    label: 'Amount your employer contributed',
                    type: 'currency',
                    tooltip: '',
                    comment: true,
                    effect: updateKeyInStore(updateKey),
                    predicate: (value) => value === 'yes',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: 'didYouReceiveStockBasedCompensationFromYourEmployer',
    label: 'Did you receive stock-based compensation from your employer?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'pleaseUploadSupportedDocumentation',
        label: 'Please upload supported documentation',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },
  {
    name: 'uploadAnnualNonUsWageStatementFormForeignEmployers',
    label: 'Upload annual non-US wage statement form foreign employers',
    subLabel: () => <p>T4, Certificat de Salarie, PAYE, etc.</p>,
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },

  {
    name: 'didYouReceiveAForeignieNonUsTaxRefund',
    label: 'Did you receive a foreign (ie non-US) tax refund?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'amountOfForeignieNonUsTaxRefund',
        label: 'Amount of foreign (ie Non-US) tax refund',
        type: 'currency',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
